import { useState } from "react";
import { useTranslation } from "react-i18next";
import { cls } from "utils/cls";

const yearList = [2025, 2024, 2023, 2022];
const yearItemCounts = { 2025: 6, 2024: 4, 2023: 6, 2022: 6 };
export const History = () => {
  const { t } = useTranslation();
  const [selectedYear, setSelectedYear] = useState(2025);

  const renderText = (year, selected) => {
    const count = yearItemCounts[year];
    if (!count) return null;
    return (
      <>
        {Array.from({ length: count }).map((_, index) => (
          <li
            key={index}
            className={cls(
              "transition-all duration-500 ease-out motion-reduce:transition-none",
              selected
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-3",
            )}
            style={{
              transitionDelay: selected ? `${150 + index * 70}ms` : "0ms",
            }}
          >
            {t(`introduction.section4.${year}.text${index + 1}`)}
          </li>
        ))}
      </>
    );
  };
  return (
    <div className="text-start">
      {yearList.map((year, index) => {
        const isSelected = year === selectedYear;
        return (
          <div key={year} className="flex">
            <div
              onClick={() => setSelectedYear(year)}
              className={cls(
                "w-16 md:w-20 flex-shrink-0 py-10 transition-all duration-300",
                isSelected ? "text-black font-bold pb-20" : "text-neutral-500",
                index === yearList.length - 1 ? "pb-56" : "",
              )}
            >
              <div className="flex items-center">
                <div
                  className={cls(
                    "text-sm cursor-pointer md:text-lg origin-left transition-all duration-300 ease-out motion-reduce:transition-none hover:text-black",
                    isSelected ? "scale-110" : "scale-100",
                  )}
                >
                  {year}
                </div>
              </div>
            </div>
            <div
              className="border-r border-neutral-400 relative cursor-pointer"
              onClick={() => setSelectedYear(year)}
            >
              <div className="absolute cursor-pointer -left-6 top-6 md:top-8 flex h-12 w-12 items-center justify-center">
                <div
                  className={cls(
                    "absolute inset-0 rounded-full cursor-pointer bg-pointColor/20 transition-all duration-500 ease-out motion-reduce:transition-none",
                    isSelected ? "scale-100 opacity-100" : "scale-50 opacity-0",
                  )}
                />
                <div
                  className={cls(
                    "absolute inset-1 rounded-full cursor-pointer bg-neutral-700/20 transition-all duration-500 ease-out motion-reduce:transition-none",
                    isSelected ? "scale-75 opacity-0" : "scale-100 opacity-100",
                  )}
                />
                <div
                  className={cls(
                    "rounded-full transition-all cursor-pointer duration-500 ease-out motion-reduce:transition-none",
                    isSelected
                      ? "h-6 w-6 bg-pointColor"
                      : "h-4 w-4 bg-neutral-700",
                  )}
                />
              </div>
            </div>
            <div className="mt-5 ml-10 md:ml-20 text-xs sm:text-md md:text-xl p-4 flex-1">
              <div
                className={cls(
                  "grid transition-[grid-template-rows] duration-500 ease-in-out motion-reduce:transition-none",
                  isSelected ? "grid-rows-[1fr]" : "grid-rows-[0fr]",
                  index === yearList.length - 1 ? "mb-20" : "",
                )}
              >
                <ul className="min-h-0 space-y-4 overflow-hidden">
                  {renderText(year, isSelected)}
                </ul>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default History;
